import {runValidationsAndSync, runValidationsAndSyncAfterChange} from '../validationsService/validationsService';
import {valueValidatableClearance} from './valueValidatableInitialize';

const onChangeValidationsEventHandler = (RMI) => (e) => {
    const value = e.target.value;
    const compId = e.syntheticEvent.id;

    runValidationsAndSyncAfterChange(RMI, compId, value);
};

const validationsEventHandler = (RMI) => (e) => runValidationsAndSync(RMI, e.syntheticEvent.id);

const updateValidationState = (RMI, compId) => runValidationsAndSync(RMI, compId);

const uploadButtonInitialize = (RMI, contextId, compId) => {
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().CHANGE, null, onChangeValidationsEventHandler(RMI));
    RMI.registerEvent(contextId, compId, RMI.getEventTypes().VALIDATE, null, validationsEventHandler(RMI));
    updateValidationState(RMI, compId);
};

const uploadButtonClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {uploadButtonInitialize, uploadButtonClearance};
